import { composeClasses } from '@/utils/compose-classes'
export interface SvgProps {
  src: string
  height?: string
  width?: string
  spinning?: boolean
  fillColor?: string
  className?: string
  'data-testid'?: string
}
export const Svg = ({
  src = '',
  height = 'auto',
  width = 'auto',
  spinning = false,
  fillColor = '#000',
  className,
  'data-testid': dataTestId
}: SvgProps) => {
  const modifiedSvg = src.replace(
    /<svg([^>]*)>/,
    `<svg$1 style="fill:${fillColor}; height: inherit; width: inherit;">`
  )

  const svgUrl = `data:image/svg+xml;base64,${btoa(modifiedSvg)}`

  const style = {
    height,
    width,
    animation: composeClasses(spinning && 'spin 2s linear infinite')
  }

  return (
    <img
      src={svgUrl}
      alt="icon"
      data-testid={dataTestId}
      className={composeClasses(className)}
      style={style}
    />
  )
}

export default Svg
